import PropTypes from 'prop-types'
import React from 'react'
import FormFieldLayout from 'layouts/FormFieldLayout'

const AccountPinField = ({
  onBlur,
  onFocus,
  onChange,
  value,
  loading,
  errorMessage,
  fieldName,
  labelText,
  isRequired,
}) => {
  const hasError = !!errorMessage
  const errorObject = {
    status: hasError,
    message: errorMessage,
  }
  const onPinChange = (event) => {
    if (/^\d{0,4}$/.test(event.target.value)) {
      onChange(event)
    }
  }
  const fieldElement = (
    <input
      type="tel"
      name={fieldName}
      className="form-input"
      id={fieldName}
      maxLength="4"
      value={value}
      onChange={onPinChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={loading}
      required={isRequired}
      autoComplete="off"
    />
  )
  return (
    <FormFieldLayout
      fieldName={fieldName}
      labelText={labelText}
      fieldElement={fieldElement}
      error={errorObject}
    />
  )
}

AccountPinField.defaultProps = {
  value: '',
  fieldName: 'accountPinField',
  labelText: 'PIN',
  loading: false,
  onFocus: undefined,
  onBlur: f => f,
  onChange: f => f,
  errorMessage: '',
  isRequired: false,
}

AccountPinField.propTypes = {
  value: PropTypes.string,
  loading: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
  fieldName: PropTypes.string,
  labelText: PropTypes.string,
  isRequired: PropTypes.bool,
}

export default AccountPinField



// WEBPACK FOOTER //
// ./components/form/AccountPinField/index.jsx